module.exports = __webpack_public_path__ + "static/fire_giant-ca4703d5df4c5672d31cd0a8d11fabc6.jpg";